import React, { useEffect, useContext } from "react";
import ApiService from "../../services/api-service";
import { useLocation } from "react-router-dom";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import notifier from "../Notifier";
import { SocketContext } from "../../context/socket";

export default function PaypalSuccess() {
  const [loading, setLoading] = React.useState(false);
  const socket = useContext(SocketContext).Socket;
  const search = useLocation().search;
  const tokens = new URLSearchParams(search).get("token");
  const payerId = new URLSearchParams(search).get("PayerID");
  const [message, setMessage] = React.useState();
  const { t } = useTranslation("common");
  const history = useHistory();

  useEffect(() => {
    if (history.location.pathname.includes("/app/payment/paypal/failed")) {
      getPaypalCancel(tokens);
    } else {
      getPaypalCapture(tokens, payerId);
    }
  }, [history.location.pathname, tokens]);

  const getPaypalCancel = async (tokens) => {
    try {
      setLoading(true);
      await ApiService.PAYPALLCANCEL(`?token=${tokens}`);
      notifier.error("Oops! User cancelled the transactions");
      setTimeout(() => {
        window.close();
      }, 3000);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getPaypalCapture = async (tokens, payerId) => {
    try {
      setLoading(true);
      const response = await ApiService.PAYPALLCAPTURE({
        orderId: tokens,
        payerId: payerId,
      });
      setMessage(response["result"]["status"]);
      if (message === "COMPLETED" || response.result.status === "COMPLETED") {
        notifier.success("Siki tokens added successfully");
        setTimeout(() => {
          window.close();
        }, 3000);
      } else {
        notifier.error("Something went wrong");
        setTimeout(() => {
          window.close();
        }, 3000);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div style={{ color: "white", textAlign: "center" }}>
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={t("loader.message1")}
        />
      ) : (
        ""
      )}
    </div>
  );
}
